import firebaseApp from "./config";

const editDetail = async (dataInput) =>{

  try {
    const authResponse = await updateInAuth(dataInput);
    console.log("editDetail -> authResponse", authResponse)
    if (authResponse && authResponse.updateData) {
      const dataToInsert = {
        phoneNumber: "+91".concat(dataInput.phoneNumber),
        userId:   dataInput.userId, //storageHelper.get("tokenId"),
        status: 'verified',
        displayName: dataInput.firstName,
        email: dataInput.email,
        device: "web",
        emailVerified: false,
        photoURL: null,
        password: dataInput.password,
        class: dataInput.userClass,
        metaData: {
          creationTime: null,
          lastSignInTime: null,
        },
        valid: true,
      };
      
      return await firebaseApp.firestore()
        .collection('User')
        .doc(dataInput.userId)
        .set(dataToInsert)
        .then(() => {
          return {
            message: 'User Register successfully.',
            status: 'ok',
            data: authResponse,
          };
        })
        .catch((error) => {
          return {
            message: error.message,
            status: 'error',
            data: null,
          };
        });
    }
    return {
      message: 'Register Not completed.',
      status: 'error',
      data: null,
    };
  } catch (error) {
    return {
      message: error.message || 'Invalid data provided.',
      status: 'error',
      data: null,
    };
  }
}

const updateInAuth = async (data) => {
console.log("updateInAuth -> data", data)
  
  try {
    let url = `https://us-central1-araapp-90f11.cloudfunctions.net/app/user/${data.userId}`;
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        displayName: data.firstName || "",
        password: data.password || '12345678',
        email: data.email || "email@yopmail.com",
      }),
    });
    let json = await response.json();
    return json;
  } catch (error) {
    return {
      data: null,
      message: error,
      status: 'error',
    };
  }
}

export {editDetail};